module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-9010HD_white-8213e51add35a0eb5be09fc088a74881.png";